module.exports = __webpack_public_path__ + "static/amare_img_12_v-86129532e08233d0b70abb05288a7d78.jpg";